<template>
  <div class="content">
    <div class="rotation">
      <div class="rotation_content">
        <div class="detail_content">
          <div class="prospectus_title">
            互联网+创业培训授课意见反馈表
          </div>
          <ul class="prospectus_ul final">
            <li v-for="(item,index) in detailList" :key="index">
              <div class="question">{{item.subject_name}}</div>
              <div class="answer ">
                <div class="checkbox" v-if="item.type === 2">
                  <el-checkbox  disabled 
                    v-for="items in item.option_list"
                    :key="items.option_id"
                    :label="items.option_id"
                    :checked="items.checked"
                    :value="items.checked">{{items.option_name}}</el-checkbox>
                </div>
                <div class="radio" v-else-if="item.type === 1">
                  <el-radio v-model="item.answer_id" disabled 
                    v-for="items in item.option_list"
                    :key="items.option_id"
                    :label="items.option_id"
                    :value="items.option_id">{{items.option_name}}</el-radio>
                </div>
                <p v-else>答：{{item.answer_result}}</p>  
              </div>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  export default{
    name:'feedbackDetail',
    components:{
    },
    data(){
      return {
        detailList:{},
      }
    },
    created(){
      this.id = this.$route.params && this.$route.params.id
      this.feedback_id = this.$route.query.feedback_id
      let params = {
        student_id:this.id,
        feedback_id:this.feedback_id,
      }
      this.getinfor(params)
    },
    mounted(){
      
    },
    methods:{
      getinfor(params){
        this.$api.user.feedbackListDetail(params)
          .then(res=>{
            if(res.code === 0){
              this.detailList = res.result
              let arr = this.detailList
              for(let i = 0;i < arr.length;i++){
                if(arr[i].type === 2){
                  for(let j = 0 ; j < arr[i].option_list.length ;j++){
                    arr[i].option_list[j].checked = false
                    if(arr[i].option_list[j].is_checked === 1){
                      arr[i].option_list[j].checked = true
                      break
                    }
                  }
                }
                if(arr[i].type === 1){
                  for(let j = 0 ; j < arr[i].option_list.length ;j++){
                    arr[i].answer_id = ''
                    if(arr[i].option_list[j].is_checked === 1){
                      arr[i].answer_id = arr[i].option_list[j].option_id
                      break
                    }
                  }
                }
              }
              this.detailList = arr
            }
          }) 
      },
    },
    watch:{
    }
  }
</script>
<style scoped lang="scss">
  @import '../../assets/scss/content.scss';
  @import '../../assets/scss/prospectusDetail.scss';
</style>